import { Lightbulb } from "@phosphor-icons/react";

export const PageAdvice = ({ title = "Good to know", items = [] }) => (
  <div data-testid="page-advice" className="mt-8 rounded-sm border border-[#0055FF]/20 bg-[#0055FF]/[0.03] p-4">
    <p className="flex items-center gap-2 text-sm font-bold text-[#0A0A0A]">
      <Lightbulb size={16} weight="fill" className="text-[#0055FF]" /> {title}
    </p>
    <ul className="mt-2 space-y-1.5">
      {items.map((t, i) => (
        <li key={`${i}-${typeof t === "string" ? t.slice(0, 24) : i}`} className="flex gap-2 text-sm text-neutral-600">
          <span className="mt-[7px] h-1 w-1 shrink-0 rounded-full bg-[#0055FF]" />
          <span>{t}</span>
        </li>
      ))}
    </ul>
  </div>
);

export default PageAdvice;
